import { RegMenReportsService } from "~/entity/RegMenReports/api/service";

import { useRegMenReportMutation } from "./useRegMenReportMutation";

export const useGetRegMenConsolidateReport = () => {
  const { data, isLoading, isError, mutate, reset } = useRegMenReportMutation(
    RegMenReportsService.GET.getRegMenByDealerConsolidate,
  );

  return {
    data,
    isLoading,
    isError,
    getRegMenConsolidateReport: mutate,
    resetRegMenConsolidateReport: reset,
  };
};
